import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from './useUser';

function AdminRoute({ children }) {
    const { isAuthenticated, isLoading, isAdmin } = useUser();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex justify-center items-center min-h-[400px]">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (!isAuthenticated || !isAdmin) {
        // Redirect to home if not authenticated or not admin
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
}

export default AdminRoute;
